/** Formatadores pt-BR compartilhados pela aba Financeiro. */

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const fmtBRL = (n: number | null | undefined): string => BRL.format(n ?? 0);

/** Compacto para eixos de gráfico: R$ 12,5 mil / R$ 1,2 mi. */
export function fmtBRLcompacto(n: number | null | undefined): string {
  const v = n ?? 0;
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `R$ ${(v / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mi`;
  if (abs >= 1_000) return `R$ ${(v / 1_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`;
  return fmtBRL(v);
}

export const fmtPct = (n: number | null | undefined): string =>
  `${(n ?? 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`;

/** ISO date → dd/mm/aaaa. */
export function fmtData(iso: string | null | undefined): string {
  if (!iso) return '—';
  const s = String(iso).slice(0, 10);
  const [a, m, d] = s.split('-');
  return a && m && d ? `${d}/${m}/${a}` : s;
}

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
/** 'YYYY-MM' → 'jul/26'. */
export function fmtMesAno(mes: string | null | undefined): string {
  if (!mes) return '—';
  const [a, m] = String(mes).split('-');
  const idx = parseInt(m, 10) - 1;
  return idx >= 0 && idx < 12 ? `${MESES[idx]}/${(a || '').slice(2)}` : String(mes);
}
